import React, { useState } from 'react';
import { Banner, Gutter, TableTransfer } from '@common/components';
import { filterableColumnBuilder } from 'works/legacy/lib/table-filters-helper';
import { OrganizationUnitType } from '@institutions/graphql';

const { filterOptionForColumns } = TableTransfer;

function generateRowKey(data: OrganizationUnitType[]) {
  return data.map((unit) => ({
    key: unit.id,
    selectKey: unit.department.id,
    disabled: !unit.canUpdateSupplierDepartment.value,
    ...unit,
  }));
}

const column = filterableColumnBuilder<OrganizationUnitType>({});

const tableColumns = [
  column({
    key: 'name',
    dataIndex: 'name',
    title: 'Unit Name',
  }),
  column({
    key: 'costCenter',
    dataIndex: 'costCenter',
    title: 'Cost Center',
  }),
  column({
    dataIndex: ['department', 'organizationBusiness', 'name'],
    key: 'department',
    title: 'Facility',
  }),
];

const transferTitles = {
  leftPlural: 'Units Available',
  leftSingular: 'Unit Available',
  rightPlural: 'Units Selected',
  rightSingular: 'Unit Selected',
};

export function UnitSelectionOnTransferTables({
  loading,
  organizationUnits,
  selectedOrganizationUnitIds,
  onOrganizationUnitIdsChange,
  headerSlot,
}: {
  headerSlot?: React.ReactNode;
  loading?: boolean;
  organizationUnits: OrganizationUnitType[];
  selectedOrganizationUnitIds: string[];
  onOrganizationUnitIdsChange: (organizationUnitIds: string[]) => void;
}) {
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  function onSelectChange(
    sourceSelectedKeys: string[],
    targetSelectedKeys: string[]
  ) {
    const newSelectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];

    setSelectedKeys(newSelectedKeys);
  }

  const filterOption = filterOptionForColumns(
    tableColumns.map(({ dataIndex }) => dataIndex!)
  );

  const hasUnauthorized =
    organizationUnits.filter(
      ({ canUpdateSupplierDepartment: { value } }) => !value
    ).length > 0;

  return (
    <>
      {headerSlot && (
        <Gutter size="md" direction="bottom">
          {headerSlot}
        </Gutter>
      )}
      {hasUnauthorized && (
        <Gutter size="md" direction="bottom">
          <Banner type="info">
            You can only update locations to units that you belong to.
          </Banner>
        </Gutter>
      )}
      <TableTransfer
        showSearch
        titles={transferTitles}
        selectKeyEnabled
        loading={loading}
        className="suppliers-management-locations-update-step-units"
        dataSource={generateRowKey(organizationUnits)}
        targetKeys={selectedOrganizationUnitIds}
        selectedKeys={selectedKeys}
        onSelectChange={onSelectChange}
        disabled={false}
        onChange={onOrganizationUnitIdsChange}
        columns={tableColumns}
        filterOption={filterOption}
      />
    </>
  );
}
